/**
 * Single source of truth for legal-document and consent-scope versions. Bump
 * a date here when what it names is materially revised — every
 * consent-capture call site reads from here, never a file-local constant.
 */
export const TOS_VERSION = "2026-07-29";
export const PRIVACY_VERSION = "2026-08-23";
export const ADS_CONSENT_VERSION = "2026-08-23"; // the prompt's scope; bumped only when what is consented to changes
